import RestAdapter from "discourse/adapters/rest";

export default class NotificationAdapter extends RestAdapter {
  cache = true;
}
